export default function PHP_HOME() {
  return (
    <div>
      <h1>PHP_HOME</h1>
    </div>
  );
}
